import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getUserDetails } from "../../../redux/Slices/UsersSlice";
import {
  FaArrowLeft,
  FaEdit,
  FaUser,
  FaEnvelope,
  FaUserShield,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useTitle } from "../../../shared/hooks/TitleContext";
import i18n from "../../../i18n/i18n";

const UserDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { setTitle } = useTitle();
  const { t } = useTranslation("global");
  const isRTL = i18n.language === "ar";
  const dir = isRTL ? "rtl" : "ltr";
  const textAlign = isRTL ? "right" : "left";

  const [userDetails, setUserDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTitle("users.details.title");
  }, [setTitle]);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        setIsLoading(true);
        const result = await dispatch(getUserDetails(id));
        if (getUserDetails.fulfilled.match(result)) {
          const response = result.payload;
          setUserDetails(response?.data || response);
        } else {
          toast.error(
            result.payload ||
              t("users.details.error", {
                defaultValue: "فشل تحميل تفاصيل المستخدم",
              }),
            { rtl: isRTL },
          );
          navigate("/users");
        }
      } catch (err) {
        toast.error(
          err.message ||
            t("users.details.error", {
              defaultValue: "فشل تحميل تفاصيل المستخدم",
            }),
          { rtl: isRTL },
        );
        navigate("/users");
      } finally {
        setIsLoading(false);
      }
    };
    if (id) {
      fetchDetails();
    }
  }, [dispatch, id, navigate, t, isRTL]);

  const handleEdit = () => {
    navigate(`/users/edit/${id}`);
  };

  const handleBack = () => {
    navigate("/users");
  };

  if (isLoading) {
    return (
      <div
        style={{
          padding: "30px",
          backgroundColor: "#14263b",
          minHeight: "calc(100vh - 80px)",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          direction: dir,
          textAlign,
        }}
      >
        {t("common.loading", { defaultValue: "جاري التحميل..." })}
      </div>
    );
  }

  if (!userDetails) {
    return (
      <div
        style={{
          padding: "30px",
          backgroundColor: "#14263b",
          minHeight: "calc(100vh - 80px)",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          direction: dir,
          textAlign,
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h5 style={{ color: "white", marginBottom: "10px" }}>
            {t("users.details.notFound", {
              defaultValue: "المستخدم غير موجود",
            })}
          </h5>
          <button
            onClick={handleBack}
            style={{
              backgroundColor: "#AC2000",
              color: "white",
              border: "none",
              padding: "12px 25px",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "bold",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              margin: "20px auto 0",
            }}
          >
            <FaArrowLeft />
            {t("common.back", { defaultValue: "رجوع" })}
          </button>
        </div>
      </div>
    );
  }

  const user = userDetails;

  return (
    <div
      style={{
        padding: "30px",
        backgroundColor: "#14263b",
        minHeight: "calc(100vh - 80px)",
        color: "white",
        direction: dir,
        textAlign,
      }}
    >
      <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
        <div
          style={{
            backgroundColor: "#1b3350",
            borderRadius: "12px",
            overflow: "hidden",
            border: "1px solid #333",
          }}
        >
          <div
            style={{
              padding: "20px",
              borderBottom: "1px solid #333",
              backgroundColor: "#1a1f2e",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "white",
                  fontFamily:
                    '"Times New Roman Bold", "Times New Roman", "Times", serif',
                }}
              >
                {t("users.details.title", { defaultValue: "تفاصيل المستخدم" })}
              </h1>
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  onClick={handleBack}
                  style={{
                    backgroundColor: "#666",
                    color: "white",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontFamily:
                      '"Times New Roman Bold", "Times New Roman", "Times", serif',
                  }}
                >
                  <FaArrowLeft />
                  {t("common.back", { defaultValue: "رجوع" })}
                </button>
                {user.email !== "admin@albarqawy.com" && (
                  <button
                    onClick={handleEdit}
                    style={{
                      backgroundColor: "#2196F3",
                      color: "white",
                      border: "none",
                      padding: "10px 20px",
                      borderRadius: "6px",
                      fontSize: "14px",
                      fontWeight: "bold",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontFamily:
                        '"Times New Roman Bold", "Times New Roman", "Times", serif',
                    }}
                  >
                    <FaEdit />
                    {t("common.edit", { defaultValue: "تعديل" })}
                  </button>
                )}
              </div>
            </div>
          </div>

          <div style={{ padding: "30px" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: "20px",
              }}
            >
              <div
                style={{
                  padding: "20px",
                  backgroundColor: "#1a1f2e",
                  borderRadius: "8px",
                  border: "1px solid #333",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "15px",
                  }}
                >
                  <FaUser style={{ color: "#AC2000", fontSize: "20px" }} />
                  <h3
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "white",
                      fontFamily:
                        '"Times New Roman Bold", "Times New Roman", "Times", serif',
                    }}
                  >
                    {t("labels.name", { defaultValue: "الاسم" })}
                  </h3>
                </div>
                <p
                  style={{
                    margin: 0,
                    color: "#ccc",
                    fontSize: "14px",
                    fontFamily:
                      '"Times New Roman Bold", "Times New Roman", "Times", serif',
                  }}
                >
                  {user.name || "-"}
                </p>
              </div>

              <div
                style={{
                  padding: "20px",
                  backgroundColor: "#1a1f2e",
                  borderRadius: "8px",
                  border: "1px solid #333",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "15px",
                  }}
                >
                  <FaEnvelope style={{ color: "#AC2000", fontSize: "20px" }} />
                  <h3
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "white",
                      fontFamily:
                        '"Times New Roman Bold", "Times New Roman", "Times", serif',
                    }}
                  >
                    {t("sign.email", { defaultValue: "البريد الإلكتروني" })}
                  </h3>
                </div>
                <p
                  style={{
                    margin: 0,
                    color: "#ccc",
                    fontSize: "14px",
                    fontFamily:
                      '"Times New Roman Bold", "Times New Roman", "Times", serif',
                  }}
                >
                  {user.email || "-"}
                </p>
              </div>

              <div
                style={{
                  padding: "20px",
                  backgroundColor: "#1a1f2e",
                  borderRadius: "8px",
                  border: "1px solid #333",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "15px",
                  }}
                >
                  <FaUserShield
                    style={{ color: "#AC2000", fontSize: "20px" }}
                  />
                  <h3
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "white",
                      fontFamily:
                        '"Times New Roman Bold", "Times New Roman", "Times", serif',
                    }}
                  >
                    {t("users.roles", { defaultValue: "الأدوار" })}
                  </h3>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {user.roles && user.roles.length > 0 ? (
                    user.roles.map(role => (
                      <span
                        key={role.id}
                        style={{
                          backgroundColor: "#AC2000",
                          color: "white",
                          padding: "6px 12px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontFamily:
                            '"Times New Roman Bold", "Times New Roman", "Times", serif',
                        }}
                      >
                        {role.name}
                      </span>
                    ))
                  ) : (
                    <span style={{ color: "#888" }}>-</span>
                  )}
                </div>
              </div>

              <div
                style={{
                  padding: "20px",
                  backgroundColor: "#1a1f2e",
                  borderRadius: "8px",
                  border: "1px solid #333",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "15px",
                  }}
                >
                  {user.is_active ? (
                    <FaCheckCircle
                      style={{ color: "#4CAF50", fontSize: "20px" }}
                    />
                  ) : (
                    <FaTimesCircle
                      style={{ color: "#f44336", fontSize: "20px" }}
                    />
                  )}
                  <h3
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "white",
                      fontFamily:
                        '"Times New Roman Bold", "Times New Roman", "Times", serif',
                    }}
                  >
                    {t("users.status", { defaultValue: "الحالة" })}
                  </h3>
                </div>
                <p
                  style={{
                    margin: 0,
                    color: user.is_active ? "#4CAF50" : "#f44336",
                    fontSize: "14px",
                    fontFamily:
                      '"Times New Roman Bold", "Times New Roman", "Times", serif',
                    fontWeight: "bold",
                  }}
                >
                  {user.is_active
                    ? t("users.active", { defaultValue: "نشط" })
                    : t("users.inactive", { defaultValue: "غير نشط" })}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
